// apps/provider/src/components/calendar/DayFlipHeader.jsx
// Single-day prev/next navigation header (lifted from the scribe appointments
// page pattern): chevrons around a centered label, with a "Back to today"
// shortcut when viewing another day.

import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const formatHeaderDate = (date) =>
  date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });

const DayFlipHeader = ({ selectedDate, isToday, todayLabel = "Today's Schedule", onPrev, onNext, onToday }) => (
  <div className="flex items-center gap-1">
    <button
      onClick={onPrev}
      className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 active:bg-gray-200 transition-colors"
      aria-label="Previous day"
    >
      <ChevronLeft className="h-4 w-4 text-gray-600" />
    </button>
    <div className="text-center min-w-[150px]">
      <h3 className="text-lg font-semibold text-gray-900">
        {isToday ? todayLabel : formatHeaderDate(selectedDate)}
      </h3>
      {!isToday && (
        <button
          onClick={onToday}
          className="text-xs text-primary hover:text-primary/80 font-medium"
        >
          Back to today
        </button>
      )}
    </div>
    <button
      onClick={onNext}
      className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 active:bg-gray-200 transition-colors"
      aria-label="Next day"
    >
      <ChevronRight className="h-4 w-4 text-gray-600" />
    </button>
  </div>
);

export default DayFlipHeader;
